.list {
  margin: 0;
  padding: 0.25rem 0.5rem;
  list-style-type: none;
}

.entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.375rem 0;
  white-space: nowrap;
}

.shortcut {
  margin-left: 1rem;
  padding: 0.25rem;
  background-color: var(--h5w-interactionHelp-shortcut--bgColor, lightgray);
  border-radius: 0.25rem;
  color: var(--h5w-interactionHelp-shortcut--color, inherit);
}
